import { ApiPlatform, ApiSyncType } from "@incendium/api";
import { getWooCommerceBackfillStatus } from "features/dataConnectors/utils/woocommerceStoreMeta";
import { useSelectedProject, usePolling } from "Hooks";
import { useExternalSyncs } from "Hooks/useExternalSyncs";
import { useMemo } from "react";

export function useWooCommerceBackfillStatus() {
  const { selectedProject } = useSelectedProject();
  const { externalSyncs, refetch } = useExternalSyncs();

  const wooSync = useMemo(
    () =>
      externalSyncs.find((s) => s.type === ApiSyncType.WOOCOMMERCE_CONNECTOR),
    [externalSyncs],
  );

  const status = useMemo(() => {
    if (!selectedProject) {
      return null;
    }

    const isWooCommerceProject =
      selectedProject.platform === ApiPlatform.PLATFORM_WOOCOMMERCE;
    if (!isWooCommerceProject && !wooSync) {
      return null;
    }

    return getWooCommerceBackfillStatus(wooSync);
  }, [selectedProject, wooSync]);

  usePolling({
    pollFn: refetch,
    interval: 5000,
    enabled: !!status,
    immediate: false,
  });

  return status;
}
